import { useCallback } from 'react'

import { useSelector } from 'react-redux'

import { useAppDispatch } from 'src/Hooks/redux'
import { getCookieByName, getUtmParameters } from 'src/Constants/functions'
import { sendSourceBusterUserEvent } from 'src/Redux/sourcebuster-process/api-actions'
import { getSourceBusterData } from 'src/Redux/sourcebuster-process'
import { getAccessToken } from 'src/Redux/auth-process/credentialsSlice/selectors'
import { clearPendingScVid, readPendingScVid } from 'src/Utils/pendingScVid'

export type SourceBusterUserEventName =
  | 'login'
  | 'google_signup'
  | 'email_signup'

const SIGNUP_EVENT_NAMES: SourceBusterUserEventName[] = [
  'google_signup',
  'email_signup',
]

interface SourceBusterUserEventParams {
  token?: string
  eventName?: SourceBusterUserEventName
}

interface SourceBusterEvents {
  sourceBusterLoginEvent: (params?: SourceBusterUserEventParams) => void
}

export const useSourceBusterEvents = (): SourceBusterEvents => {
  const dispatch = useAppDispatch()

  const sourceBusterData = useSelector(getSourceBusterData)
  const savedToken = useSelector(getAccessToken)

  const utmObj = getUtmParameters(getCookieByName('soundCampaignUtm'))

  const sourceBusterLoginEvent = useCallback(
    ({ token, eventName = 'login' }: SourceBusterUserEventParams = {}) => {
      if (!token && !savedToken) {
        return
      }

      const scVid = SIGNUP_EVENT_NAMES.includes(eventName)
        ? readPendingScVid()
        : null

      void dispatch(
        sendSourceBusterUserEvent({
          token: token || savedToken,
          gclid: utmObj.gclid || '',
          savedData: sourceBusterData,
          eventName,
          ...(scVid && { scVid }),
        }),
      ).then((result) => {
        if (scVid && sendSourceBusterUserEvent.fulfilled.match(result)) {
          clearPendingScVid()
        }
      })
    },
    [dispatch, savedToken, sourceBusterData, utmObj.gclid],
  )

  return {
    sourceBusterLoginEvent,
  }
}
